import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"];

  toggle(e) {
    // There's a limitation in height animations, which is nothing to do with Tailwind, just CSS.
    // If you want to animate, you have to have a specific start and end size.  To make this happen
    // We use an arbitrarily large max-height which should be big enough to accommodate the content.
    this.contentTarget.classList.toggle("max-h-0");
    this.contentTarget.classList.toggle("max-h-[1000px]");

    if (this.element.getAttribute("data-autosubmit") === "true") {
      this.element.closest("form").requestSubmit();
    }
  }
}
